import { Link } from 'react-router-dom';
import { Cloud, Download, Link2, Settings, UserCircle } from 'lucide-react';

import { getAllSources } from '@/sources/registry';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export function MorePage() {
  const loginSources = getAllSources().filter((source) => source.capabilities.login);

  return (
    <div className="flex flex-col gap-4">
      <header>
        <h1 className="text-2xl font-bold tracking-tight">More</h1>
        <p className="text-sm text-muted-foreground">
          Account, source connections, settings, and install guidance live here.
        </p>
      </header>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            <UserCircle className="h-4 w-4" />
            Account
          </CardTitle>
          <CardDescription>Sign in and manage Bunko account sync.</CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild variant="outline">
            <Link to="/account">Open account</Link>
          </Button>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            <Link2 className="h-4 w-4" />
            Connected sources
          </CardTitle>
          <CardDescription>Refresh source cookies or restore synced sessions.</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-wrap gap-2">
          {loginSources.map((source) => (
            <Button key={source.id} asChild variant="outline" size="sm">
              <Link to={`/connect/${source.id}`}>{source.name}</Link>
            </Button>
          ))}
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            <Settings className="h-4 w-4" />
            Settings
          </CardTitle>
          <CardDescription>Theme, proxy URL, connected account status, and blacklist.</CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild variant="outline">
            <Link to="/settings">Open settings</Link>
          </Button>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            <Download className="h-4 w-4" />
            Install Bunko
          </CardTitle>
          <CardDescription>
            Use your browser&apos;s Add to Home Screen / Install App action to launch Bunko
            like a mobile app.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          <p>
            On iOS, open Safari&apos;s Share sheet and choose Add to Home Screen. On Android
            Chrome, use Install App from the browser menu when available.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            <Cloud className="h-4 w-4" />
            Data
          </CardTitle>
          <CardDescription>
            Favorites, reading history, blacklist, preferences, and saved searches are stored
            locally and can sync through your Bunko account.
          </CardDescription>
        </CardHeader>
      </Card>
    </div>
  );
}
